module.exports = __webpack_public_path__ + "media/images/smart_phone/toplogo-d8bf174e83387d07b0434bf78dacb73c.png";